import { isNil } from 'ramda'
import numeral from 'numeral'
import { toFixed } from './toFixed'

/**
 * sister utility function to formatPrice, formats a number into
 * a price but keeping the cents/decimal places using numeral package
 * @param {*} price | price to format
 * @param {*} defaultText | in case price is undefined
 * @returns {string} formatted price but with the cents included
 */
export const formatPriceCents = (price, defaultText = '') =>
  isNil(price) ? defaultText : numeral(toFixed(2)(price)).format('$0,0.00')
